import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormulaireCoordonneesMouvementAdresseModel } from 'src/app/models/formulaire/formulaire-coordonnees-mouvement-adresse.model';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../../constantes/cybermetrie.enum';
@Component({
  selector: 'app-questionnaire-dgag',
  templateUrl: './questionnaire-dgag.component.html',
  standalone: false,
})
export class QuestionnaireDGAGComponent {
  @Input() formGroup!: FormGroup<FormulaireCoordonneesMouvementAdresseModel>;

  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);

  // Define control names as constants to avoid hardcoded strings and type mismatches
  readonly DETENTION_DGAG_APPARIE = 'detentionDGAGApparie' as const;
  readonly DETIENT_ASSURANCES_CONTROL = 'detientAssurances' as const;
  readonly CHANGEMENT_ASSURANCE_FAIT_CONTROL = 'changementAssurancesFait' as const;
  readonly PREFERENCE_APPEL_ASSURANCES_CONTROL = 'preferenceAppelAssurances' as const;
  readonly PREFERENCE_MOMENT_ASSURANCES_CONTROL = 'preferenceMomentAssurances' as const;

  get hasDetention(): boolean {
    return this.formGroup.get(this.DETENTION_DGAG_APPARIE)?.value === true;
  }

  get afficherQuestionChangementFait(): boolean {
    return (
      this.formGroup.get(this.DETIENT_ASSURANCES_CONTROL)?.value === 'true' || this.hasDetention
    );
  }

  get afficherQuestionPreferenceAppel(): boolean {
    return this.formGroup.get(this.CHANGEMENT_ASSURANCE_FAIT_CONTROL)?.value === 'false';
  }

  get afficherQuestionPreferenceMoment(): boolean {
    return this.formGroup.get(this.PREFERENCE_APPEL_ASSURANCES_CONTROL)?.value === 'true';
  }

  ajouterQuestionChangementFait(): void {
    this.formGroup.addControl(this.CHANGEMENT_ASSURANCE_FAIT_CONTROL, this.createControl());
  }

  detentionChange(event: CustomEvent): void {
    this.cybermetrieCoordonneesService.interractionsForms(
      CybermetrieEnum.ACTION_DETENTION_ASSURANCE,
      event.detail.value,
    );
  }

  retirerQuestionsChangementFaitEtMoins(): void {
    this.formGroup.removeControl(this.CHANGEMENT_ASSURANCE_FAIT_CONTROL);
    this.formGroup.removeControl(this.PREFERENCE_APPEL_ASSURANCES_CONTROL);
    this.formGroup.removeControl(this.PREFERENCE_MOMENT_ASSURANCES_CONTROL);
  }

  ajouterQuestionPreferenceAppel(): void {
    this.formGroup.addControl(this.PREFERENCE_APPEL_ASSURANCES_CONTROL, this.createControl());
  }

  retirerQuestionPreferenceAppelEtMoins(): void {
    this.formGroup.removeControl(this.PREFERENCE_APPEL_ASSURANCES_CONTROL);
    this.formGroup.removeControl(this.PREFERENCE_MOMENT_ASSURANCES_CONTROL);
  }

  changementFaitChange(event: CustomEvent): void {
    this.cybermetrieCoordonneesService.interractionsForms(
      CybermetrieEnum.ACTION_ADRESSE_ASSURANCE,
      event.detail.value,
    );
  }

  ajouterQuestionPreferenceMoment(): void {
    this.formGroup.addControl(this.PREFERENCE_MOMENT_ASSURANCES_CONTROL, this.createControl());
  }

  preferenceAppelChange(event: CustomEvent): void {
    this.cybermetrieCoordonneesService.interractionsForms(
      CybermetrieEnum.ACTION_PREFERENCE_CONTACT,
      event.detail.value,
    );
  }

  retirerQuestionPreferenceMoment(): void {
    this.formGroup.removeControl(this.PREFERENCE_MOMENT_ASSURANCES_CONTROL);
  }

  preferenceMomentChange(event: CustomEvent): void {
    this.cybermetrieCoordonneesService.interractionsForms(
      CybermetrieEnum.ACTION_PREFERENCE_HEURE,
      event.detail.value,
    );
  }

  private createControl() {
    return new FormControl<string | null>(null, {
      nonNullable: true,
      validators: [Validators.required],
    });
  }
}
